import Services from "../network/Services";
export const mapApi = "https://maps.googleapis.com/maps/api/js";

export const mapKey = 'AIzaSyBaUn22pwovCzOxH7Uthivbd8_ScMkaEAI';

export const supportEmail='accounts@agingOptions.com'



export const EnquiryRegistrationId = 1;
export const CounterWalkInId = 3;
export const CounterCheckInId = 4;
export const CounterPlanner = 7;
export const PAIDId = 8;
export const UNPAIDId = 9;
export const ConstantEmail = "@aoe.com";
export const ConstantText = "1234567890";
export const ConstantText1 = "(123) 456-7890";
export const ConstantVenue = "Tucson, Arizona";
export const Constantlocate = "USA Location- to be announced soon";
export const ConstantZip = "";



//self checkin
export const selfWalkInId = 2;
export const selfCheckInId = 5;
export const selfPlannerId = 6;


///UserType
export const Registered = 'REGISTERED';
export const checkIn = 'CHECK_IN';
export const PlannerBooking = 'PLANNER_BOOKED';
export const plannerFeePaid = 'PLANNER_FEE_PAID';
export const plannerFeeUnpaid = 'PLANNER_FEE_UNPAID';



export const selfCheckingCheckedIn = 'CHECKEDIN';
export const selfPlannerCheckedIn = 'PLANNER';
export const selfClassroomCheckedIn = 'CLASSROOM';
// export const LeadStackerToken = "4e138444-4400-40f7-bb5c-2588d1b15910";//LPL
// export const LeadStackerToken1 = "6606a0c3-2cbf-4a3a-b12d-484c15559f61";//AO



export const LeadStackerToken = "pit-639c80d3-a78a-491d-a75b-1a6c2f0a0dc9";//LPL
export const LeadStackerTokenLocationID = "Mw3qj1MwTgSSMsPt2Zcp";//LPL
export const LeadStackerToken1 = "pit-2a609d2e-7d28-452b-8c99-12862be1ac69";//AO
export const LeadStackerToken1LocationID = "jwqNWFuDfnFYjfDbfGfu";//AO




export const defaultIPAddress = '127.0.0.1';





export const isNotValidNullUndefinedfile = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        return true;
    }
    return false
}
export function capitalizeName(name) {
    let words = name.split(' ');

    let capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    let capitalizedName = capitalizedWords.join(' ');

    return capitalizedName;
}
function normalizeTagParts(tag) {
  return tag.replace(/\s/g, "").toLowerCase().split(",");
}
function findMatchingTags(existingTags = [], newTags = []) {
  if (!Array.isArray(existingTags) || !Array.isArray(newTags)) return [];

  return existingTags.filter((existingTag) => {
    const existingParts = normalizeTagParts(existingTag);
    return newTags.some((newTag) => {
      const newParts = normalizeTagParts(newTag);
      return existingParts.join(",") === newParts.join(",");
    });
  });
}
function mapTags(JsonObj) {
  return Array.isArray(JsonObj?.tag) ? JsonObj?.tag?.map((item) => `${item}`) : [];
}
function buildTagsForRequest(JsonObj) {
  if (JsonObj?.method === "PUT") return []; // PUT doesn't apply new tags — always an array, never `false`
  return mapTags(JsonObj);
}
function resolveAsErr(context, err) {
  console.error(`[leadApi] ${context} failed:`, err?.response?.data || err?.message || err);
  return "err";
}
function extractContacts(res) {
  const contacts = res?.data?.contacts;
  return Array.isArray(contacts) ? contacts : [];
}
// ── API calls ──────────────────────────────────────────────────────────
export const leadPostApi = (JsonObj) => {
  return new Promise((resolve) => {
    Services.postContactLead(JsonObj)
      .then((res) => resolve(res))
      .catch((err) => resolve(resolveAsErr("leadPostApi", err)));
  });
};
export const leadPostContactApi = (json, aWithDates) => {
const subtenantId = sessionStorage.getItem("subtenantId");
  const seminarObj = JSON.parse(sessionStorage.getItem("seminarObj"))?.seminarSubtenantId;
  return new Promise((resolve) => {
    Services.postContactLeadRegist(json, aWithDates,(subtenantId || seminarObj)).then((res) => {
        const responseId = res?.data?.contact?.id;
        const existingTags = res?.data?.contact?.tags || [];
        const deleteTag = findMatchingTags(existingTags, aWithDates);

        resolve({
          id: responseId,
          tags: aWithDates,
          deleteTagss: deleteTag,
          contact: "NEW",
        });
      })
      .catch((err) => resolve(resolveAsErr("leadPostContactApi", err)));
  });
};

export const leadDeleteApi = (JsonObj) => {
  return new Promise((resolve) => {
    Services.deleteContactLead(JsonObj)
      .then((res) => resolve(res))
      .catch((err) => resolve(resolveAsErr("leadDeleteApi", err)));
  });
};

export const leadPutApi = (JsonObj, tag) => {
  return new Promise((resolve) => {
    Services.putContactLeadRegist(JsonObj, tag)
      .then((res) => resolve(res))
      .catch((err) => resolve(resolveAsErr("leadPutApi", err)));
  });
};
export const GetResponse = (JsonObj) => {
  return new Promise((resolve) => {
    const aWithDates = buildTagsForRequest(JsonObj);
     const subtenantId = sessionStorage.getItem("subtenantId");
     const seminarObj = JSON.parse(sessionStorage.getItem("seminarObj"))?.seminarSubtenantId;
    Services.getContactLead(JsonObj?.email,(subtenantId || seminarObj))
      .then((res) => {
        const contacts = extractContacts(res);
        if (contacts.length === 0) {
          resolve("The email address is invalid.");
          return;
        }

        if (contacts.length > 1) {
        }

        const responseId = contacts?.[0]?.id;
        const deleteTag = JsonObj?.method !== "PUT" ? findMatchingTags(contacts[0]?.tags, aWithDates) : [];

        resolve({id: responseId,tags: aWithDates,deleteTagss: deleteTag,isContact: true});
      })
      .catch((err) => {
        const message = err?.response?.data?.email?.message;
        console.error("[leadApi] GetResponse failed:", err?.response?.data || err?.message || err);
        resolve(message || "err");
      });
  });
};
export const leadCommonApi = async (result, method, tag) => {
  if (result === "err") return "err";

  if (method === "POST") {
    if (result?.contact === "NEW") {
      return result;
    }
    return leadPostApi(result);
  }

  if (method === "DELETE") {
    return leadDeleteApi(result);
  }

  if (method === "PUT") {
    return leadPutApi(result, tag);
  }

  console.warn(`[leadApi] leadCommonApi called with unrecognized method: ${method}`);
  return undefined;
};
export const leadGetApi = async (JsonObj, json) => {
  const result = await GetResponse(JsonObj);
  if (result === "The email address is invalid.") {
    const aWithDates = mapTags(JsonObj);
    return leadPostContactApi(json, aWithDates);
  }
  return result;
};
export const getLocalISO = () => {
    const d = new Date();
    // convert to local timezone ISO (not UTC)
    const tzOffset = d.getTimezoneOffset() * 60000;
    const localISO = new Date(d - tzOffset).toISOString().slice(0, -1);
    return localISO;
  };
